import { render } from "./px-questionary-currency.vue?vue&type=template&id=635bda25&ts=true"
import script from "./px-questionary-currency.vue?vue&type=script&lang=ts"
export * from "./px-questionary-currency.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__